/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * * `HUMAN` - Human
 * * `AI` - AI
 * * `SYSTEM` - System
 * @export
 */
export const MessageTypeEnum = {
    Human: 'HUMAN',
    Ai: 'AI',
    System: 'SYSTEM'
} as const;
export type MessageTypeEnum = typeof MessageTypeEnum[keyof typeof MessageTypeEnum];


export function instanceOfMessageTypeEnum(value: any): boolean {
    for (const key in MessageTypeEnum) {
        if (Object.prototype.hasOwnProperty.call(MessageTypeEnum, key)) {
            if (MessageTypeEnum[key as keyof typeof MessageTypeEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function MessageTypeEnumFromJSON(json: any): MessageTypeEnum {
    return MessageTypeEnumFromJSONTyped(json, false);
}

export function MessageTypeEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): MessageTypeEnum {
    return json as MessageTypeEnum;
}

export function MessageTypeEnumToJSON(value?: MessageTypeEnum | null): any {
    return value as any;
}

export function MessageTypeEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): MessageTypeEnum {
    return value as MessageTypeEnum;
}

